import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgGalleryIcon = (props) => /* @__PURE__ */ _jsxs("svg", {
	width: 56,
	height: 56,
	viewBox: "0 0 56 56",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: [/* @__PURE__ */ _jsxs("g", {
		filter: "url(#filter0_d_2934_44985)",
		children: [
			/* @__PURE__ */ _jsx("circle", {
				cx: 28,
				cy: 24,
				r: 24,
				fill: "#BCA4FF"
			}),
			/* @__PURE__ */ _jsx("path", {
				d: "M18.5808 31.0098L18.5608 31.0298C18.2908 30.4398 18.1208 29.7698 18.0508 29.0298C18.1208 29.7598 18.3108 30.4198 18.5808 31.0098Z",
				fill: "white"
			}),
			/* @__PURE__ */ _jsx("path", {
				d: "M25.0011 22.3801C26.3155 22.3801 27.3811 21.3146 27.3811 20.0001C27.3811 18.6857 26.3155 17.6201 25.0011 17.6201C23.6867 17.6201 22.6211 18.6857 22.6211 20.0001C22.6211 21.3146 23.6867 22.3801 25.0011 22.3801Z",
				fill: "white"
			}),
			/* @__PURE__ */ _jsx("path", {
				d: "M32.19 14H23.81C20.17 14 18 16.17 18 19.81V28.19C18 29.28 18.19 30.23 18.56 31.03C19.42 32.93 21.26 34 23.81 34H32.19C35.83 34 38 31.83 38 28.19V25.9V19.81C38 16.17 35.83 14 32.19 14ZM36.37 24.5C35.59 23.83 34.33 23.83 33.55 24.5L29.39 28.07C28.61 28.74 27.35 28.74 26.57 28.07L26.23 27.79C25.52 27.17 24.39 27.11 23.59 27.65L19.85 30.16C19.63 29.6 19.5 28.95 19.5 28.19V19.81C19.5 16.99 20.99 15.5 23.81 15.5H32.19C35.01 15.5 36.5 16.99 36.5 19.81V24.61L36.37 24.5Z",
				fill: "white"
			})
		]
	}), /* @__PURE__ */ _jsx("defs", { children: /* @__PURE__ */ _jsxs("filter", {
		id: "filter0_d_2934_44985",
		x: 0,
		y: 0,
		width: 56,
		height: 56,
		filterUnits: "userSpaceOnUse",
		colorInterpolationFilters: "sRGB",
		children: [
			/* @__PURE__ */ _jsx("feFlood", {
				floodOpacity: 0,
				result: "BackgroundImageFix"
			}),
			/* @__PURE__ */ _jsx("feColorMatrix", {
				in: "SourceAlpha",
				type: "matrix",
				values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
				result: "hardAlpha"
			}),
			/* @__PURE__ */ _jsx("feOffset", { dy: 4 }),
			/* @__PURE__ */ _jsx("feGaussianBlur", { stdDeviation: 2 }),
			/* @__PURE__ */ _jsx("feComposite", {
				in2: "hardAlpha",
				operator: "out"
			}),
			/* @__PURE__ */ _jsx("feColorMatrix", {
				type: "matrix",
				values: "0 0 0 0 0.716667 0 0 0 0 0.716667 0 0 0 0 0.716667 0 0 0 0.2 0"
			}),
			/* @__PURE__ */ _jsx("feBlend", {
				mode: "normal",
				in2: "BackgroundImageFix",
				result: "effect1_dropShadow_2934_44985"
			}),
			/* @__PURE__ */ _jsx("feBlend", {
				mode: "normal",
				in: "SourceGraphic",
				in2: "effect1_dropShadow_2934_44985",
				result: "shape"
			})
		]
	}) })]
});
export default SvgGalleryIcon;
